export enum ReceiverTypesEnum {
  IFRAME = "IFRAME",
}
